'use client';

import React from 'react';
import AdsenseAd from './AdsenseAd';
import { AD_SLOTS, getMinHeightForAdType } from '../../utilities/ads';

/**
 * Below Title Ad - High visibility zone at the top of content
 * Highest CTR placement
 */
export function BelowTitleAd() {
  return (
    <div className='w-full mx-auto my-4'>
      <AdsenseAd adSlot={AD_SLOTS.BELOW_TITLE} adFormat='auto' responsive={true} style={{ display: 'block', minHeight: `${getMinHeightForAdType('display')}px` }} adLabel='below-title' />
    </div>
  );
}

/**
 * First Paragraph Ad - In-article native ad
 * High engagement placement
 */
export function FirstParagraphAd() {
  return (
    <div className='w-full my-4'>
      <AdsenseAd adSlot={AD_SLOTS.FIRST_PARAGRAPH} adFormat='in-article' responsive={true} style={{ display: 'block', minHeight: `${getMinHeightForAdType('in-article')}px` }} adLabel='first-paragraph' />
    </div>
  );
}

/**
 * Mid Content Ad - Multiplex format for related content feel
 * Good for long-form content
 */
export function MidContentAd() {
  return (
    <div className='w-full my-6'>
      <AdsenseAd adSlot={AD_SLOTS.MID_CONTENT} adFormat='multiplex' responsive={true} style={{ display: 'block', minHeight: `${getMinHeightForAdType('multiplex')}px` }} adLabel='mid-content' />
    </div>
  );
}

/**
 * End Content Ad - Placed at the end of content
 * Good engagement when users finish reading
 */
export function EndContentAd() {
  return (
    <div className='w-full my-6'>
      <AdsenseAd adSlot={AD_SLOTS.END_CONTENT} adFormat='auto' responsive={true} style={{ display: 'block', minHeight: `${getMinHeightForAdType('display')}px` }} adLabel='end-content' />
    </div>
  );
}

/**
 * Side Ad - For desktop sidebar placement
 * Sticky for better visibility
 */
export function SideAd() {
  return (
    <div className='w-[300px] lg:w-[300px] sticky top-5'>
      <AdsenseAd adSlot={AD_SLOTS.SIDEBAR} adFormat='auto' responsive={false} style={{ display: 'block', minHeight: `${getMinHeightForAdType('sidebar')}px`, width: '300px' }} adLabel='sidebar' />
    </div>
  );
}

/**
 * In-Feed Ad - For placement between items in a list
 * Designed to blend with content
 */
export function InFeedAd({ height = 250 }) {
  return (
    <div className='w-full'>
      <AdsenseAd adSlot={AD_SLOTS.IN_FEED} adFormat='auto' responsive={true} style={{ display: 'block', minHeight: `${height}px` }} adLabel='in-feed' />
    </div>
  );
}

/**
 * Sticky Mobile Ad - Mobile-only footer ad
 * High visibility on mobile devices
 */
export function StickyMobileAd() {
  return (
    <div className='md:hidden fixed bottom-0 left-0 w-full bg-background z-50 shadow-lg border-t'>
      <AdsenseAd adSlot={AD_SLOTS.STICKY_MOBILE} adFormat='auto' responsive={true} style={{ display: 'block', minHeight: `${getMinHeightForAdType('mobile')}px` }} adLabel='sticky-mobile' />
    </div>
  );
}
